// extracted by mini-css-extract-plugin
export default {"Milestone":"style_Milestone__NLWuo","Title":"style_Title__XNMSr","count":"style_count__UnwLk"};